import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FieldLookupService {
  public values: { [k: string]: any[]} = {}
  private valueUpdates = new Subject<{ fieldName: string; values: any[] }>();
  readonly valueUpdates$ = this.valueUpdates.asObservable();

  constructor() { }

  cacheValues(fieldName: string, values: any[]) {
    this.values[fieldName] = values;
  }

  initSelectValues(fieldName: string, newValues: any[]) {
    this.cacheValues(fieldName, newValues);
  }

  updateSelectValues(fieldName: string, newValues: any[]) {
    this.cacheValues(fieldName, newValues);
    this.valueUpdates.next({ fieldName, values: newValues });
  }
}
